import React from "react";
import { useState, useEffect } from "react";
import { baseUrl } from '../shared.js';
import '../pages/App.css';
import {
  FormControl,
  Button,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

function ExcelExport() {
    var [companies, setCompanies] = useState([]);
    var [types, setTypes] = useState([]);
    var [locations, setLocations] = useState([]);
    var [selectedCompany, setSelectedCompany] = useState(localStorage.getItem('company'));
    var [selectedType, setSelectedType] = useState("");
    var [selectedLocation, setSelectedLocation] = useState("");
    const [calibrationDialogOpen, setCalibrationDialogOpen] = useState(false);
    const [calibrationExporting, setCalibrationExporting] = useState(false);
    // Lower bound for the renewals report — defaults to 12 months ago so the report
    // doesn't drag in every overdue asset that has ever existed.
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);
    const [calibrationFromDate, setCalibrationFromDate] = useState(twelveMonthsAgo.toISOString().slice(0, 10));





    useEffect(() => {
          const url = baseUrl + 'export/assetExportCompanies';
            fetch(url, {
              method: 'GET',
              headers: {
                  'username': localStorage.getItem('username'),
                  'bToken': localStorage.getItem('bToken')
              }})
              .then((res) => {
                return res.json();
            }).then((json) => {
                console.log(json)
                setCompanies(json);
                console.log('this: ',companies)
            })
            .catch((err) => {
               console.log(err.message);
            });
          },[])  

    useEffect(() => {
  // Only fetch if types is empty
  if (types.length === 0) {
    const url = baseUrl + 'export/assetExportTypes';
    fetch(url, {
      method: 'GET',
      headers: {
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
        'selectedCompany': selectedCompany
      }
    })
    .then((res) => res.json())
    .then((json) => {
      console.log('Types: ',json);
      setTypes(json);
    })
    .catch((err) => {
      console.log(err.message);
    });
  }
}, [types]); 

const getLocationsForType = async (exportType) => {
  // Only fetch if locations is empty
  if (locations.length === 0) {
    const url = baseUrl + 'export/assetExportTypeLocations';
    fetch(url, {
      method: 'GET',
      headers: {
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
        'selectedCompany': selectedCompany,
        'selectedType': exportType
      }
    })
    .then((res) => res.json())
    .then((json) => {
      console.log('locations: ',json);
      setLocations(json);
      setSelectedType(exportType);
    })
    .catch((err) => {
      console.log(err.message);
    });
  }
};

const clearLocations = () => {
  setLocations([]);
}

const getLocationExportData = async (exportLocation) => {
  const url = baseUrl + 'export/assetRegisterExportByTypeAndLocation';

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'username': localStorage.getItem('username'),
      'bToken': localStorage.getItem('bToken'),
      'exportType': selectedType,
      'selectedCompany': selectedCompany,
      'exportLocation': exportLocation
    }
  });

  // --- If backend returned 401 / 500, stop here ---
  if (!response.ok) {
    const errTxt = await response.text();
    console.error("Export failed:", errTxt);
    alert("Export failed: " + errTxt);
    return;
  }

  // --- Extract filename (safe way) ---
  const contentDisposition = response.headers.get("content-disposition");
  let filename = "export.xlsx";

if (contentDisposition) {
  const match = contentDisposition.match(/filename="(.+?)"/);
  if (match && match[1]) {
    filename = match[1];
  }
}

const blob = await response.blob();

const linkurl = URL.createObjectURL(blob);
const link = document.createElement("a");
link.href = linkurl;
link.download = filename;
link.click();
URL.revokeObjectURL(url);
};

const getExportData = async (selectedType) => {
  const url = baseUrl + 'export/assetRegisterExportByType';

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'username': localStorage.getItem('username'),
      'bToken': localStorage.getItem('bToken'),
      'exportType': selectedType,
      'selectedCompany': selectedCompany
    }
  });

  // --- If backend returned 401 / 500, stop here ---
  if (!response.ok) {
    const errTxt = await response.text();
    console.error("Export failed:", errTxt);
    alert("Export failed: " + errTxt);
    return;
  }

  // --- Extract filename (safe way) ---
  const contentDisposition = response.headers.get("content-disposition");
  let filename = "export.xlsx";

if (contentDisposition) {
  const match = contentDisposition.match(/filename="(.+?)"/);
  if (match && match[1]) {
    filename = match[1];
  }
}

const blob = await response.blob();

const linkurl = URL.createObjectURL(blob);
const link = document.createElement("a");
link.href = linkurl;
link.download = filename;
link.click();
URL.revokeObjectURL(url);
};

const getAllExportData = async (exportType) => {
  const url = baseUrl + 'export/assetRegisterExportAll';

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'username': localStorage.getItem('username'),
      'bToken': localStorage.getItem('bToken'),
      'selectedCompany': selectedCompany
    }
  });

  // --- If backend returned 401 / 500, stop here ---
  if (!response.ok) {
    const errTxt = await response.text();
    console.error("Export failed:", errTxt);
    alert("Export failed: " + errTxt);
    return;
  }

  // --- Extract filename (safe way) ---
  const contentDisposition = response.headers.get("content-disposition");
  let filename = "export.xlsx";

if (contentDisposition) {
  const match = contentDisposition.match(/filename="(.+?)"/);
  if (match && match[1]) {
    filename = match[1];
  }
}

const blob = await response.blob();

const linkurl = URL.createObjectURL(blob);
const link = document.createElement("a");
link.href = linkurl;
link.download = filename;
link.click();
URL.revokeObjectURL(url);
};


const exportCalibrationRenewals = async (months) => {
  setCalibrationDialogOpen(false);
  setCalibrationExporting(true);
  try {
    const response = await fetch(baseUrl + 'export/calibrationRenewals', {
      method: 'GET',
      headers: {
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
        'selectedCompany': selectedCompany,
        'months': String(months),
        'fromDate': calibrationFromDate || '',
      },
    });
    if (!response.ok) {
      alert('Export failed: ' + await response.text());
      return;
    }
    const contentDisposition = response.headers.get('content-disposition');
    let filename = `CalibrationRenewals_${months}months.xlsx`;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+?)"/);
      if (match && match[1]) filename = match[1];
    }
    const blob = await response.blob();
    const linkurl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = linkurl;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(linkurl);
  } catch (err) {
    alert('Export error: ' + err.message);
  } finally {
    setCalibrationExporting(false);
  }
};

 return (
<div className="admin">
<Dialog open={calibrationDialogOpen} onClose={() => setCalibrationDialogOpen(false)}>
  <DialogTitle>Export Upcoming Calibration Renewals</DialogTitle>
  <DialogContent>
    <p style={{ marginBottom: 16, fontSize: '0.9rem', color: '#555' }}>
      The report includes assets whose calibration expires between the <strong>start date</strong> below
      and the selected number of months into the future. Anything expiring before the start date is excluded.
    </p>
    <TextField
      label="Start date (from)"
      type="date"
      size="small"
      fullWidth
      value={calibrationFromDate}
      onChange={e => setCalibrationFromDate(e.target.value)}
      InputLabelProps={{ shrink: true }}
      sx={{ mb: 2 }}
    />
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Button variant="contained" disabled={!calibrationFromDate} onClick={() => exportCalibrationRenewals(3)}>3 Months</Button>
      <Button variant="contained" disabled={!calibrationFromDate} onClick={() => exportCalibrationRenewals(6)}>6 Months</Button>
      <Button variant="contained" disabled={!calibrationFromDate} onClick={() => exportCalibrationRenewals(12)}>12 Months</Button>
    </div>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setCalibrationDialogOpen(false)}>Cancel</Button>
  </DialogActions>
</Dialog>

{ companies?.length > 1 ? (
<div>
    <FormControl
          margin="dense"
     fullWidth>
     <InputLabel shrink htmlFor="companyTitle">
    Company *
  </InputLabel>
        <Select
          native
          required
          label="Company   *"
          inputProps={{
            id: 'companyTitle',
          }}
          fullWidth
          onChange={(e) => {
            setSelectedCompany(e.target.value);
            setTypes([])
          }}>
          {
          companies?.map((companies) => {
          return <option value={companies.company} key={companies.company}>{companies.description}</option>
        })
      }
  </Select>
     </FormControl>
</div>
):null}
{ locations?.length === 0 ? (
<div>
<TableContainer>
    <Table aria-label="simple table" margin="dense">
      <TableBody>
        {types?.map((types, index) => (
           <TableRow key={index}>
            <TableCell align="center"><Button sx={{ minWidth: 250}} variant="contained" onClick={() => getLocationsForType(types.TYPE)} disabled={types.TYPE === "No results found"}>{types.TYPE}</Button></TableCell>
          </TableRow>
        ))}
        {types?.some(t => t.TYPE !== "No results found") ? (
        <TableRow>
          <TableCell align="center">
            <Button
              sx={{ minWidth: 250, maxWidth: 250, whiteSpace: 'normal', lineHeight: 1.3, backgroundColor: '#f57c00', '&:hover': { backgroundColor: '#e65100' } }}
              variant="contained"
              disabled={calibrationExporting}
              onClick={() => setCalibrationDialogOpen(true)}
            >
              {calibrationExporting ? 'Generating...' : <span>Export Upcoming<br/>Calibration Renewals</span>}
            </Button>
          </TableCell>
        </TableRow>
        ) : null}
        {types?.length > 1 ? (
           <TableRow>
            <TableCell align="center"><Button sx={{ minWidth: 250}} variant="contained" onClick={() => getAllExportData()}>Download All Asset Data <br/> (No Location Filter)</Button></TableCell>
          </TableRow>
        ):null}
      </TableBody>
  </Table>
</TableContainer>
</div>
):

<div>
<TableContainer>
    <Table aria-label="simple table" margin="dense">
      <TableBody>
        {locations?.map((locations, index) => (
           <TableRow key={index}>
            <TableCell align="center"><Button sx={{ minWidth: 250}} variant="contained" onClick={() => getLocationExportData(locations.siteLocation)} disabled={locations.siteLocation === "No results found"}>{locations.siteLocation}</Button></TableCell>
          </TableRow>
        ))}
        {types?.length > 1 ? (
           <TableRow>
            <TableCell align="center"><Button sx={{ minWidth: 250}} variant="contained" onClick={() => getExportData(selectedType)}>Download All {selectedType} Data</Button></TableCell>
          </TableRow>
        ):null}
        {types?.length > 1 ? (
           <TableRow>
            <TableCell align="center"><Button sx={{ minWidth: 250, backgroundColor: '#ff0000', '&:hover': { backgroundColor: '#cc0000' }}} variant="contained" onClick={() => clearLocations()}>Reset Selected Type</Button></TableCell>
          </TableRow>
        ):null}
      </TableBody>
  </Table>
</TableContainer>
</div>
}
</div>

)}
export default ExcelExport